const CHEATING_TYPES = {
  none: "Not detected",
  detected: "Detected",
  likely: "Likely",
};

export default CHEATING_TYPES;
